var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var editor_2d = require("editor-2d");
var colors = require("./../../../colors/colors.js");

/**
 * Created with JetBrains RubyMine.
 * User: kbruneel
 * Date: 6/27/13
 * Time: 2:08 PM
 * To change this template use File | Settings | File Templates.
 */

var TangentHandleView = function (gui, tangentHandleModel, parentGroup, layers) {
    var self = this;
    this.gui = gui;
    this.tangentHandleModel = tangentHandleModel;
    this.pointHandleModel = this.tangentHandleModel.pointHandleModel;
    this.pathInteractionModel = this.tangentHandleModel.pathInteractionModel;
    this.segmentModel = this.tangentHandleModel.segmentModel;
    this.neighbourSegmentModel = this.tangentHandleModel.neighbourSegmentModel;

    if(!layers.interaction) return;

    this.cameraModel = this.gui.editorModel.cameraModel();

    this.initGroups(parentGroup, [layers.interaction, layers.interactionControl], tangentHandleModel);

    this.svgGroup = this.getGroupInfo(layers.interaction).svgGroup;
    this.controlGroup = this.getGroupInfo(layers.interactionControl).svgGroup;

    function updateView() {
        if (self.tangentHandleModel.isAlive())
            self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    }
    this.cameraModel.viewS.onChange(self, updateView, 10);
    this.pointHandleModel.coord.onChange(self, updateView, 10);
    // this.pointHandleModel.mode.onChange(self, function(){
    //     if (self.tangentHandleModel.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    // },10);
    this.tangentHandleModel.coord.onChange(self, updateView, 10);
    this.segmentModel.infocus.onChange(self, updateView, 10);
    this.pointHandleModel.selected.onChange(self, updateView, 10);
    if(this.neighbourSegmentModel()) this.neighbourSegmentModel().infocus.onChange(self, updateView, 10);

    this.tangentHandleModel.onDie({}, function(){
        self.removeSvg();
        self.cameraModel.viewS.removeHandlers(self);
        self.pointHandleModel.coord.removeHandlers(self);
        self.tangentHandleModel.coord.removeHandlers(self);
        self.segmentModel.infocus.removeHandlers(self);
    },101);

    this.drawIfNeeded();
};

lib_core.mixin(TangentHandleView, editor_2d.DrawingElement);

module.exports = TangentHandleView;


TangentHandleView.prototype.drawIfNeeded = function () {
    if (this.tangentHandleModel.isAlive()
            && (this.segmentModel.infocus()
                || this.neighbourSegmentModel() && this.neighbourSegmentModel().infocus()
                || this.pointHandleModel.selected()
                )
            ) {
        this.draw();
    } else {
        this.emptySvgGroups();
    }
};

TangentHandleView.prototype.draw = function () {
    var self = this;

    $(this.svgGroup).empty();
    $(this.controlGroup).empty();

    var c = self.tangentHandleModel.coord();
    var point = self.pointHandleModel.coord();

    var size = 10 / this.cameraModel.viewS();
    var stroke = 1 / this.cameraModel.viewS();

    var opacity;
    if (!this.tangentHandleModel.primary
        && this.pointHandleModel.object.type() == cio_datamodel.PathPointMode.SMOOTH ) {
        opacity = 0.3;
    } else {
        opacity = 1;
    }

    this.gui.svg.rect(this.svgGroup,c.x-size/2,c.y-size/2,size,size,{
        'fill' : this.selected ? colors.handleFillSelected : colors.handleFill,
        'fillOpacity' : 1,
        'stroke' : colors.handleStroke,
        'strokeWidth' : stroke
    });

    this.gui.svg.line(this.svgGroup,point.x,point.y,c.x,c.y,{
        'stroke' : colors.handleStroke,
        'opacity' : opacity,
        'strokeWidth' : stroke
    });

    var handle = this.gui.svg.rect(this.controlGroup, c.x - size / 2, c.y - size / 2, size, size);

    $(handle).mousedown(function (event) {
        return self.onMouseDown(event);
    });
};

TangentHandleView.prototype.onMouseDown = function (event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
            .fromJSEvent(event)
            .element( this.tangentHandleModel )
            .data( 'mouseCoord', this.gui.relativeMouseCoord(event) )
            .data( 'notFocusable', true );

    return this.gui.stateMachine.handle(cEvent);
};
